import classNames from 'classnames'
import React from 'react'
import { HeaderDesktop } from './header-desktop/HeaderDesktop'
import { HeaderMobile } from './header-mobile/HeaderMobile'
import styles from './Header.module.scss'
import type { NavigationMenuContentType } from '@/tools/ui/components/navigation-menu/NavigationMenu'

export enum HeaderColorEnum {
  brand = 'brand',
  background = 'background',
}
export type HeaderColorType = keyof typeof HeaderColorEnum

type Props = {
  color?: HeaderColorType
  hasScrollLocationDrawer?: boolean
  shouldShowAddress?: boolean
  shouldShowSearch?: boolean
  navigationMenuContent?: NavigationMenuContentType
  shouldShowUserButton?: boolean
  children?: React.ReactNode
}
export const Header = ({
  color = 'brand',
  shouldShowAddress = false,
  shouldShowSearch = false,
  hasScrollLocationDrawer = false,
  navigationMenuContent: NavigationMenuContent,
  shouldShowUserButton = true,
  children,
}: Props) => (
  <header className={classNames(styles.header, styles[`${color}ColorHeader`])} id="header">
    <div id="original-header">
      <HeaderDesktop
        className={styles.desktopVisibility}
        color={color}
        hasScrollLocationDrawer={hasScrollLocationDrawer}
        shouldShowAddress={shouldShowAddress}
        shouldShowSearch={shouldShowSearch}
        shouldShowUserButton={shouldShowUserButton}
      >
        {children}
      </HeaderDesktop>
      <HeaderMobile
        NavigationMenuContent={NavigationMenuContent}
        className={styles.mobileVisibility}
        color={color}
        shouldShowAddress={shouldShowAddress}
        shouldShowSearch={shouldShowSearch}
        shouldShowUserButton={shouldShowUserButton}
      >
        {children}
      </HeaderMobile>
    </div>
    <div className={styles.portal} id="header-sticky-portal" />
  </header>
)
